import { mapState, mapGetters, mapActions } from 'vuex'

import Loader from '~/components/features/homes/Loader'

import HomeCardMissing from '~/components/features/homes/CardMissing'
import HomeRegistrationBlocked from '~/components/features/homes/RegistrationBlocked'
import HomeError from '~/components/features/homes/HomeError'
import HomeNotRegistered from '~/components/features/homes/NotRegistered'
import HomeRegistered from '~/components/features/homes/Registered'

import MixinWhiteLabel from '~/mixins/isWhiteLabel'

export default {
  mixins: [MixinWhiteLabel],
  data: () => ({
    isRegisteringAuto: false,
  }),
  computed: {
    ...mapState('layout', ['isIframeOpen']),

    ...mapState('card', ['isLoaded', 'error']),
    ...mapGetters('card', ['hasCard']),

    ...mapState('auth', ['isRegistrationBlocked']),
    ...mapGetters('auth', ['isRegisteredToPartner']),
  },
  async mounted () {
    this.registerAutoIfIframeOpened()
    this.loadHomeIfRegistered()
  },
  watch: {
    isIframeOpen: 'registerAutoIfIframeOpened',
    isRegisteredToPartner: 'loadHomeIfRegistered',
  },
  methods: {
    ...mapActions(['addToast', 'addToastGenericError']),

    async registerAutoIfIframeOpened () {
      if (!this.isWhiteLabel) return
      if (this.isRegisteredToPartner) return
      if (!this.isIframeOpen) return

      if (this.isRegisteringAuto) { return }
      this.isRegisteringAuto = true

      let response
      try {
        response = await this.$axios.post(
          '/api/register_auto',
          {
            clientId: this.$route.query.clientId,
            userExternalId: this.$route.query.userExternalId,
            userExternalEmail: this.$route.query.userExternalEmail,
          },
        )
      } catch (error) {
        if (error.response.data.redirect) {
          this.$router.push(error.response.data.redirect)
          return
        }

        this.$airbrake.notifyInAsync(error, { locator: 'AutoRegister' }, { store: this.$store })
        this.addToastGenericError()
        this.isRegisteringAuto = false
        return
      }

      await this.$store.dispatch('auth/configureUser', {
        user: response.data.user,
        partner: response.data.partner,
        fidmarques: response.data.fidmarques,
        userExternalEmail: this.$route.query.userExternalEmail,
      })
      this.isRegisteringAuto = false
    },

    ...mapActions('card', ['fetchCardAndRewards']),

    async loadHomeIfRegistered () {
      if (!this.isRegisteredToPartner) return

      this.fetchCardAndRewards()
    },
  },

  render (h) {
    if (this.isRegistrationBlocked) {
      return h(HomeRegistrationBlocked)
    }

    if (this.error) {
      return h(HomeError, { props: { error: this.error } })
    }

    if (!this.isRegisteredToPartner) {
      if (this.isWhiteLabel) {
        // automatic register to partner will occur once user open the iframe
        return h(Loader)
      } else {
        return h(HomeNotRegistered)
      }
    }

    if (!this.isLoaded) return h(Loader)

    if (!this.hasCard) {
      return h(HomeCardMissing)
    }

    return h(HomeRegistered)
  },
}
